(function () {
  'use strict';

  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var nav = document.getElementById('MobileNavigation');

    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.hidden = expanded;
      document.body.classList.toggle('mobile-menu-open', !expanded);
    });
  }

  function initTypingPlaceholders(root) {
    var scope = root || document;
    var inputs = scope.querySelectorAll('[data-typing-input]');

    inputs.forEach(function (input) {
      if (input.dataset.typingInitialized === 'true') return;
      input.dataset.typingInitialized = 'true';

      var rawItems = input.getAttribute('data-typing-items') || '';
      var items = rawItems
        .split('|')
        .map(function (item) { return item.trim(); })
        .filter(Boolean);

      if (!items.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var typingSpeed = Number(input.getAttribute('data-typing-speed')) || 80;
      var pause = Number(input.getAttribute('data-typing-pause')) || 1500;
      var itemIndex = 0;
      var charIndex = 0;
      var deleting = false;
      var timer;

      function tick() {
        if (document.activeElement === input || input.value) {
          timer = window.setTimeout(tick, 250);
          return;
        }

        var phrase = items[itemIndex];
        input.placeholder = phrase.slice(0, charIndex);

        if (!deleting) {
          charIndex += 1;
          if (charIndex > phrase.length) {
            deleting = true;
            timer = window.setTimeout(tick, pause);
            return;
          }
        } else {
          charIndex -= 1;
          if (charIndex < 0) {
            deleting = false;
            itemIndex = (itemIndex + 1) % items.length;
            charIndex = 0;
          }
        }

        timer = window.setTimeout(tick, deleting ? Math.max(35, typingSpeed / 2) : typingSpeed);
      }

      tick();

      input.addEventListener('remove', function () {
        window.clearTimeout(timer);
      });
    });
  }


  function initCartCommerce() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawerShell = document.querySelector('[data-cart-drawer-shell]');
    var drawerBody = document.querySelector('[data-cart-drawer-body]');
    var drawerFooter = document.querySelector('[data-cart-drawer-footer]');
    var lastTrigger = null;

    function endpoint(path) {
      return root + String(path).replace(/^\/+/, '');
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoney(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    }

    function requestJson(url, options) {
      options = options || {};
      var headers = options.headers || {};
      headers.Accept = 'application/json';
      options.headers = headers;
      options.credentials = 'same-origin';

      return fetch(url, options).then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || error.message || 'Cart request failed.');
        });
      });
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (counter) {
        counter.textContent = count;
        counter.hidden = count < 1;
      });
    }

    function openDrawer() {
      if (!drawerShell) return;
      lastTrigger = document.activeElement;
      drawerShell.classList.add('is-open');
      drawerShell.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      var close = drawerShell.querySelector('[data-cart-drawer-close]');
      if (close) close.focus();
    }

    function closeDrawer() {
      if (!drawerShell) return;
      drawerShell.classList.remove('is-open');
      drawerShell.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    function renderCart(cart) {
      updateCartCount(cart.item_count);
      if (!drawerBody || !drawerFooter) return;

      if (!cart.items.length) {
        drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
        drawerFooter.innerHTML = '<a class="button button--outline" href="' + endpoint('collections/all') + '">Continue shopping</a>';
        return;
      }

      drawerBody.innerHTML = cart.items.map(function (item, index) {
        var image = item.image
          ? '<a class="cart-drawer__line-image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '&width=180" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>'
          : '<div class="cart-drawer__line-image"></div>';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__line-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';

        return '<div class="cart-drawer__line">' +
          image +
          '<div class="cart-drawer__line-details">' +
            '<a class="cart-drawer__line-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<p class="cart-drawer__line-quantity">Qty: ' + item.quantity + '</p>' +
            '<button class="cart-drawer__remove" type="button" data-cart-remove-line="' + (index + 1) + '">Remove</button>' +
          '</div>' +
          '<strong class="cart-drawer__line-price">' + formatMoney(item.final_line_price) + '</strong>' +
        '</div>';
      }).join('');

      drawerFooter.innerHTML =
        '<div class="cart-drawer__subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>' +
        '<div class="cart-drawer__actions">' +
          '<a class="button button--outline" href="' + endpoint('cart') + '">View cart</a>' +
          '<a class="button button--primary" href="' + endpoint('checkout') + '">Checkout</a>' +
        '</div>';
    }

    function getCart() {
      return requestJson(endpoint('cart.js')).then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }

    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        getCart().then(openDrawer).catch(function () {
          window.location.href = endpoint('cart');
        });
      });
    });

    document.querySelectorAll('[data-cart-drawer-close]').forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-cart-remove-line]');
      if (!removeButton || !drawerShell || !drawerShell.contains(removeButton)) return;

      removeButton.disabled = true;
      requestJson(endpoint('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: Number(removeButton.getAttribute('data-cart-remove-line')),
          quantity: 0
        })
      }).then(renderCart).catch(function () {
        removeButton.disabled = false;
      });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-cart-add-form]');
      if (!form) return;

      event.preventDefault();
      var button = event.submitter || form.querySelector('[type="submit"]');
      var originalText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }

      requestJson(endpoint('cart/add.js'), {
        method: 'POST',
        body: new FormData(form),
        headers: {}
      }).then(getCart).then(function () {
        if (button) button.textContent = 'Added';
        openDrawer();
      }).catch(function () {
        if (button) button.textContent = 'Try again';
      }).finally(function () {
        if (!button) return;
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 700);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawerShell && drawerShell.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }


  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header || header.dataset.stickyInitialized === 'true') return;
    header.dataset.stickyInitialized = 'true';
    function update() { header.classList.toggle('is-scrolled', window.scrollY > 8); }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initSlideshows(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
      if (slideshow.dataset.slideshowInitialized === 'true') return;
      slideshow.dataset.slideshowInitialized = 'true';
      var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.cbi-slideshow__slide'));
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var interval = Math.max(3000, Number(slideshow.dataset.slideshowInterval) || 6000);
      var effect = slideshow.dataset.slideshowTransition || 'fade';
      slideshow.classList.add('cbi-slideshow--' + effect);
      var index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
      function advance() {
        var previous = slides[index];
        var nextIndex = (index + 1) % slides.length;
        var next = slides[nextIndex];

        if (effect === 'slide') {
          if (slideshow.dataset.slideshowAnimating === 'true') return;
          slideshow.dataset.slideshowAnimating = 'true';

          previous.classList.add('is-leaving');
          previous.classList.remove('is-active');
          next.classList.remove('is-leaving');
          next.classList.add('is-active');

          var finishTransition = function () {
            previous.classList.remove('is-leaving');
            slideshow.dataset.slideshowAnimating = 'false';
          };

          previous.addEventListener('transitionend', finishTransition, { once: true });
          window.setTimeout(finishTransition, 900);
        } else {
          previous.classList.remove('is-active');
          next.classList.add('is-active');
        }

        index = nextIndex;
      }
      window.setInterval(advance, interval);
    });
  }

  function initCategoryScroll(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-category-scroll]').forEach(function (rail) {
      var section = rail.closest('.category-section');
      if (!section || rail.dataset.scrollInitialized === 'true') return;

      rail.dataset.scrollInitialized = 'true';

      var prev = section.querySelector('[data-category-scroll-prev]');
      var next = section.querySelector('[data-category-scroll-next]');

      function getStep() {
        var firstCard = rail.querySelector('.category-card');
        if (!firstCard) return Math.max(rail.clientWidth * 0.75, 320);
        var styles = window.getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= maxScroll - 2;
      }

      function scroll(direction) {
        rail.scrollTo({
          left: Math.max(0, rail.scrollLeft + direction * getStep()),
          behavior: 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  }

  function initProductGalleries(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryInitialized === 'true') return;
      gallery.dataset.galleryInitialized = 'true';
      gallery.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-product-media-trigger]');
        if (!trigger) return;
        var id = trigger.getAttribute('data-product-media-trigger');
        gallery.querySelectorAll('[data-product-media]').forEach(function (media) {
          var active = media.getAttribute('data-product-media') === id;
          media.hidden = !active;
          media.classList.toggle('is-active', active);
          if (!active) media.querySelectorAll('video').forEach(function (video) { video.pause(); });
        });
        gallery.querySelectorAll('[data-product-media-trigger]').forEach(function (button) {
          var active = button === trigger;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      });
    });
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    initMobileMenu();
    initStickyHeader();
    initSlideshows(document);
    initCategoryScroll(document);
    initProductGalleries(document);
    initTypingPlaceholders(document);
    initCartCommerce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSlideshows(event.target);
    initCategoryScroll(event.target);
    initProductGalleries(event.target);
    initTypingPlaceholders(event.target);
  });
})();
